/* eslint-disable */
import axios from 'axios'

export default {
  LOGIN_URL: '/api/auth/login',
  REFRESH_URL: '/api/auth/refresh',
  LOGIN_TWO_FACTOR_URL: '/api/auth/loginTwoFactor',
  RESET_PASSWORD_URL: '/api/auth/resetPassword',
  VERIFICATION_URL: '/api/auth/verificationCode',
  VALIDATION_URL: 'api/auth/validateCode',
  axios: axios,

  user: {
    authenticated: !!localStorage.getItem('access_token'),
    first_name: localStorage.getItem('first_name'),
    user_role: localStorage.getItem('user_role'),
    email: localStorage.getItem('email')
  },

  sendVerificationCode(creds, success, failure) {
    axios.post(this.VERIFICATION_URL, creds).then(() => {
      success()
    }).catch((err) => {
      failure(err)
    })
  },

  validateVerificationCode(creds, success, failure) {
    axios.post(this.VALIDATION_URL, creds).then(() => {
      success()
    }).catch((err) => {
      failure(err)
    })
  },

  login(context, creds, success, failure) {
    axios.post(this.LOGIN_URL, creds).then((data) => {
      let token = data.data.access_token
      localStorage.setItem('access_token', token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token

      this.checkAuth(success)
    }).catch((err) => {
      failure(err)
    })
  },

  refreshId: null,

  refreshTask (successCallback) {
    if(localStorage.getItem('access_token')) {
      this.refresh.bind(this, successCallback)()
    }
  },

  loginTwoFactor(context, creds, success, failure) {
    axios.post(this.LOGIN_TWO_FACTOR_URL, creds).then((data) => {
      let token = data.data.access_token
      localStorage.setItem('access_token', token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token

      this.checkAuth(success)

    }).catch((err) => {
      failure(err)
    })
  },

  logout() {
    localStorage.removeItem('access_token')
    this.user.authenticated = false
    router.push({name: "Login"})
  },

  resetPassword(context, creds, success, failure) {
    axios.post(this.RESET_PASSWORD_URL, creds).then((data) => {
      this.checkAuth(success)
    }).catch((err) => {
      failure(err)
    })
  },

  forgotPassword(context, creds, success, failure) {
    axios.post(this.RESET_PASSWORD_URL, creds).then((data) => {
      success()
    }).catch((err) => {
      failure(err)
    })
  },

  checkAuth(successCallback, failCallback) {
    var jwt = localStorage.getItem('access_token')
    if(jwt) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
      this.refreshTask.bind(this, successCallback)()
      clearInterval(this.refreshId);
      this.refreshId = setInterval(this.refreshTask.bind(this), 1800000);
      this.user.authenticated = true
    }
    else {
      localStorage.removeItem('access_token')
      this.user.authenticated = false
      if (failCallback) {
        failCallback()
      }
    }
  },

  getAuthHeader() {
    return {
      'Authorization': 'Bearer ' + localStorage.getItem('id_token')
    }
  },

  refresh(successCallback) {
    axios.post('/api/auth/refresh', {}).then((data) => {
      let token = data.data.access_token
      localStorage.setItem('access_token', token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
      this.user.email = data.data.email
      localStorage.setItem('email', this.user.email)
      this.user.first_name = data.data.first_name
      localStorage.setItem('first_name', this.user.first_name)
      this.user.user_role = data.data.user_role
      localStorage.setItem('user_role', this.user.user_role)
      this.user.authenticated = true
      if (successCallback) {
        successCallback()
      }
    }).catch((err) => {
      localStorage.removeItem('access_token')
      this.user.authenticated = false
      router.push({name: "Login"})
    })

  },

}



// WEBPACK FOOTER //
// ./src/auth.js